<template>
    <div>
        <template v-if="type === 'select'">
            <v-select :value="value"
                      :items="items"
                      :label="label"
                      :item-text="itemText"
                      :item-value="itemValue"
                      filled
                      outlined
                      class="custom mb-0"
                      hide-details="auto"
                      @change="changeSelect"></v-select>
        </template>
        <div v-if="type === 'chip'" class="d-flex flex-wrap flex-sm-nowrap">
            <v-chip class="mr-2 flex-shrink-0 item-filter v-size--custom-small"
                    :input-value="value.length === 0"
                    @click="resetValues" v-html="itemResetText">
                {{ itemResetText }}
            </v-chip>
            <v-item-group multiple
                          @change="changeChip">
                <v-item v-for="(item, index) in items"
                        :key="index"
                        :value="item.id"
                        v-slot:default="{ active, toggle }">
                    <v-chip :class="{
                                'item-filter': true,
                                'v-size--custom-small': true,
                                'icon-chip': itemText === 'icon'
                            }"
                            class="mr-2"
                            :input-value="value.length > 0 && value.includes(item.id)"
                            @click="toggle">
                        <template v-if="itemText === 'icon'">
                            <v-img width="15px" height="15px" :src="item[itemText]"></v-img>
                        </template>
                        <template v-else>
                            {{ item[itemText] }}
                        </template>
                    </v-chip>
                </v-item>
            </v-item-group>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'item-filter',
        props: {
            value: {},
            label: {
                type: String,
            },
            items: {
                required: true,
                type: Array,
            },
            type: {
                default: 'select',
                type: String,
            },
            itemLabel: {},
            itemText: {},
            itemValue: {},
            itemResetText: {
                type: String,
            },
        },
        methods: {
            changeSelect(e) {
                this.$emit('input', e);
            },
            changeChip(selected) {
                this.$emit('input', selected);
            },
            resetValues() {
                this.value.length = 0;
                this.$emit('input', []);
            },
        },
    }
</script>
